import axios from '@axios'

export default {
  namespaced: true,
  state: {
    ufs: [],
  },
  getters: {
    getUfs: state => [...new Set(state.ufs)],
  },
  mutations: {
    SET_UFS(state, payload) {
      state.ufs = payload
    },
  },
  actions: {
    GET_UFS({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/ufs')
          .then(response => {
            commit('SET_UFS', response.data.ufs)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    GET_UFS_BY_UF({ commit }, uf) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/ufs?q=${uf}`)
          .then(response => {
            commit('SET_UFS', response.data.ufs)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
